import {
  get_feeder_score_area,
  get_feeder_score_center,
  get_feeder_score_region,
} from '../../../../../utils/api';

/**
 * Obtiene Feeder Score usando el endpoint correspondiente al nivel activo.
 *
 * @param {object} params - Contexto actual de navegación y consulta.
 * @param {'centro'|'area'|'region'} params.level - Nivel seleccionado.
 * @param {string} params.region - Región activa.
 * @param {string} params.area - Área activa cuando corresponde.
 * @param {string} params.center - Centro activo cuando corresponde.
 * @param {string} params.startDate - Fecha inicial aceptada por la API.
 * @param {number} params.dayRange - Cantidad de días solicitados.
 * @param {string} params.server - Servidor configurado.
 * @returns {Promise<object>} Registros de score indexados por fecha y entidad.
 */
export function fetchFeederScores({ level, region, area, center, startDate, dayRange, server, exactRegion = false }) {
  if (level === 'area') {
    return get_feeder_score_area(region, area, startDate, dayRange, server);
  }
  if (level === 'region') {
    return get_feeder_score_region(region, startDate, dayRange, server, exactRegion ? { granularity: 'center' } : {});
  }
  return get_feeder_score_center(region, area, center, startDate, dayRange, server);
}
